/*
 * @Descripttion:
 * @version:
 * @Author: wl
 * @Date: 2020-05-13 13:27:23
 * @LastEditors: wl
 * @LastEditTime: 2020-06-07 10:09:40
 */

import axios from "../axios";

/*
 * 用户管理模块
 */

// 保存
export const save = data => {
  return axios({
    url: "/admin/service/sys_user_saveAndUpdate",
    method: "post",
    data
  });
};
// 删除
export const batchDelete = data => {
  return axios({
    url: "/admin/service/DelData",
    method: "post",
    data
  });
};
// 分页查询
export const findPage = data => {
  return axios({
    url: "/admin/service/getAUser_List ",
    method: "post",
    data
  });
};
// 查找用户的菜单权限标识集合/admin/service/sys_meny_getPerms
//获取权限标识码列表
export const findPermissions = data => {
  return axios({
    url: "/admin/service/sys_meny_getPerms",
    method: "post",
    data
  });
};
//新增，修改，删除单位
export const sys_company_operation = data => {
  return axios({
    url: "/admin/service/sys_company_operation",
    method: "post",
    data
  });
};

//访客次数统计
export const sys_visitor_count = data => {
  return axios({
    url: "/admin/service/sys_visitor_count",
    method: "post",
    data
  });
};

//病例添加

export const ywpt_data_edit = data => {
  return axios({
    url: "/admin/service/ywpt_data_edit",
    method: "post",
    data
  });
};
//病例列表
export const ywpt_data_list = data => {
  return axios({
    url: "/admin/service/ywpt_data_list",
    method: "post",
    data
  });
};
//疑似重复人员列表
export const person_suspected_duplicate = data => {
  return axios({
    url: "/admin/service/person_suspected_duplicate",
    method: "post",
    data
  });
};

export const sys_personMap_update = data => {
  return axios({
    url: "/admin/service/sys_personMap_update",
    method: "post",
    data
  });
};

// 养老人员列表
export const oldPerson = data => {
  return axios({
    url: "/admin/service/old_sign_list",
    method: "post",
    data
  });
};
// 养老人员添加
export const oldPersonAdd = data => {
  return axios({
    url: "/admin/service/old_sign_add",
    method: "post",
    data
  });
};
// 养老人员添加
export const oldPersonDel = data => {
  return axios({
    url: "/admin/service/old_sign_del",
    method: "post",
    data
  });
};



// WEBPACK FOOTER //
// ./src/http/moudules/user.js